var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _path9, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 341.92 239.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e60012;}.cls-2{fill:#7278ad;}.cls-3{fill:#d5696b;}.cls-4{fill:#965342;}.cls-5{fill:#9f126f;}.cls-6{fill:#fff209;}.cls-7{fill:#00458d;}.cls-8{fill:#2d9d8b;}.cls-9{fill:#a4d0c7;}.cls-10{fill:#c28f39;}.cls-11{fill:#87b932;}.cls-12{fill:#38a1db;}.cls-13{fill:#f08300;}.cls-14{fill:#daa1c7;}.cls-15{fill:#1b933b;}.cls-16{fill:#b1b294;}.cls-17{fill:#e40073;}.cls-18{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "171.24 100.28 0 200.56 27.51 200.56 171.24 100.28"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "171.24 100.28 41.4 200.56 55.19 200.56 171.24 100.28"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "82.78 200.56 171.24 100.28 124.18 200.56 82.78 200.56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "137.97 200.56 171.24 100.28 151.77 200.56 137.97 200.56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "171.24 100.28 193.16 200.56 220.76 200.56 171.24 100.28"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "171.24 100.28 234.56 200.56 262.15 200.56 171.24 100.28"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "169.92 100.28 272.93 200.56 300.53 200.56 169.92 100.28"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "171.24 100.28 314.32 200.56 341.92 200.56 171.24 100.28"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "171.24 100.28 0 0 13.8 0 171.24 100.28"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "172.68 101.39 27.6 0 41.4 0 172.68 101.39"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "55.19 0 171.24 100.28 68.99 0 55.19 0"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "82.78 0 171.23 100.25 124.18 0 82.78 0"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "137.97 0 171.24 100.28 179.37 0 137.97 0"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "171.24 100.28 193.16 0 220.76 0 171.24 100.28"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "171.24 100.9 234.56 0 262.15 0 171.24 100.9"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "171.24 100.28 272.93 0 300.53 0 171.24 100.28"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "171.24 100.28 314.32 0 341.92 0 171.24 100.28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M13.72,220.56a5.58,5.58,0,0,1,1.69,4.31,5.67,5.67,0,0,1-1.69,4.35,6.77,6.77,0,0,1-4.82,1.59H2.85v8.28H0V219H8.9A6.81,6.81,0,0,1,13.72,220.56Zm-2.19,6.95a3.81,3.81,0,0,0,0-5.23,4.47,4.47,0,0,0-3-.91H2.85v7H8.51A4.52,4.52,0,0,0,11.53,227.51Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M47.81,239.09V219h2.84v20.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M100.09,235.74a7.22,7.22,0,0,1-2.87,2.73,9.35,9.35,0,0,1-4.65,1.07,9.64,9.64,0,0,1-5-1.28,8.51,8.51,0,0,1-3.33-3.66A12.28,12.28,0,0,1,83.05,229a12.14,12.14,0,0,1,1.19-5.55,8.49,8.49,0,0,1,3.33-3.65,9.64,9.64,0,0,1,5-1.28,9.46,9.46,0,0,1,4.56,1,6.94,6.94,0,0,1,2.76,2.52,6,6,0,0,1,.94,3h-3a5.27,5.27,0,0,0-1.44-2.9A5.14,5.14,0,0,0,92.57,221a5.94,5.94,0,0,0-4.84,2.14,10.82,10.82,0,0,0,0,11.89,5.94,5.94,0,0,0,4.84,2.14,5.2,5.2,0,0,0,4-1.41,5.92,5.92,0,0,0,1.5-3.41h3A6.78,6.78,0,0,1,100.09,235.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M149.84,221.46h-6.76v17.63h-2.84V221.46h-6.79V219h16.39Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M198.27,231.82a8.1,8.1,0,0,1-1,4.22,6.55,6.55,0,0,1-2.85,2.61,10.05,10.05,0,0,1-8.27,0,6.55,6.55,0,0,1-2.85-2.61,8.1,8.1,0,0,1-1-4.22V219h2.85v12.56a5.81,5.81,0,0,0,1.32,4.23,5.24,5.24,0,0,0,3.86,1.32,5.17,5.17,0,0,0,3.84-1.32,5.81,5.81,0,0,0,1.31-4.23V219h2.85Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M243.65,239.09l-5.29-8.53h-4.84v8.53h-2.85V219h9.49a7,7,0,0,1,4.83,1.53,5.42,5.42,0,0,1,1.71,4.24,5.56,5.56,0,0,1-1.34,3.86,5.94,5.94,0,0,1-3.82,1.83l5.44,8.65Zm-10.13-10.93h6.31a4.5,4.5,0,0,0,3-.87,3.16,3.16,0,0,0,1-2.54,3.12,3.12,0,0,0-1-2.5,4.44,4.44,0,0,0-3-.88h-6.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M282.22,227.29h10.51v2.36H282.22v7h11v2.48h-13.8V219h13.8v2.39h-11Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M337.06,221.83a5.65,5.65,0,0,0-3.34-1,5.48,5.48,0,0,0-3.24.89,2.71,2.71,0,0,0-1.26,2.32,2.12,2.12,0,0,0,.81,1.8,6.58,6.58,0,0,0,2.34,1l4.12.93a12.8,12.8,0,0,1,2.84.92,4.53,4.53,0,0,1,1.87,1.74,5.93,5.93,0,0,1,.72,3.14,5,5,0,0,1-2.2,4.41,9.93,9.93,0,0,1-5.8,1.53,9.39,9.39,0,0,1-6.11-1.82,6.28,6.28,0,0,1-2.23-5.25h2.93c.17,3.16,2,4.73,5.47,4.73a6.33,6.33,0,0,0,3.7-.93,3,3,0,0,0,1.34-2.59,2.61,2.61,0,0,0-.92-2.18,6.89,6.89,0,0,0-2.66-1.14l-4.28-1a8,8,0,0,1-3.53-1.64,4.4,4.4,0,0,1-1.31-3.54,4.75,4.75,0,0,1,1-3,6.09,6.09,0,0,1,2.66-2,11,11,0,0,1,7.73.06,6.38,6.38,0,0,1,2.78,2.14,5.63,5.63,0,0,1,1,3.35h-2.93A3.57,3.57,0,0,0,337.06,221.83Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 13.71,
    y: 186.89,
    width: 13.8,
    height: 13.67
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 41.4,
    y: 106.65,
    width: 13.8,
    height: 93.91
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    width: 13.8,
    height: 200.56
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M82.79,0V200.56h41.39V0Zm27.59,186.89H96.58V13.67h13.8Z"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "55.19 92.97 41.4 92.97 41.4 0 27.6 0 27.6 106.64 41.4 106.64 55.19 106.64 68.99 106.64 68.99 0 55.19 0 55.19 92.97"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "234.56 0 234.56 106.64 248.36 106.64 248.36 186.89 234.56 186.89 234.56 200.56 248.36 200.56 262.15 200.56 262.15 92.97 248.36 92.97 248.36 13.67 262.15 13.67 262.15 0 248.36 0 234.56 0"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "272.93 0 272.93 106.64 286.73 106.64 286.73 186.89 272.93 186.89 272.93 200.56 286.73 200.56 300.53 200.56 300.53 92.97 286.73 92.97 286.73 13.67 300.53 13.67 300.53 0 286.73 0 272.93 0"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "193.16 0 193.16 200.56 206.96 200.56 220.76 200.56 220.76 186.89 206.96 186.89 206.96 106.64 220.76 106.64 220.76 92.97 206.96 92.97 206.96 13.67 220.76 13.67 220.76 0 206.96 0 193.16 0"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "151.77 0 137.97 0 137.97 200.56 151.77 200.56 151.77 13.67 165.57 13.67 165.57 200.56 179.37 200.56 179.37 0 165.57 0 151.77 0"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "341.92 13.67 341.92 0 314.32 0 314.32 200.56 328.12 200.56 341.92 200.56 341.92 186.89 328.12 186.89 328.12 106.64 341.92 106.64 341.92 92.97 328.12 92.97 328.12 13.67 341.92 13.67"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/Logo-1.a309ccc956654af569b107f1a20e1c6b.svg";
export { ForwardRef as ReactComponent };